<template>
  <div id="app">
    <Header :type="type" :keyword="keyword" v-if="header"></Header>
    <router-view @searchTarget="handleSearch" @barTarget="handleBar"></router-view>
    <Footer v-if="footer"></Footer>
  </div>
</template>

<script>
import Header from './components/header.vue';
import Footer from './components/footer.vue'
export default {
  name: 'app',
  data() {
    return {
      //是否显示头部栏
      header: true,
      //是否显示底栏
      footer: true,
      keyword: "",
      type: "1"
    }
  },
  components: {
    Header,
    Footer
  },
  methods: {
    handleBar(newVal) {
      this.header = newVal.header;
      this.footer = newVal.footer;
    },
    handleSearch(newVal) {
      this.keyword = newVal.keyword;
      this.type = newVal.type;
    }
  }
}
</script>

<style>
body,
html {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, SimSun, sans-serif;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -webkit-tap-highlight-color: transparent;
  background: #f6f6f6;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}
.page-container {
  width: 1140px;
  padding: 0;
  margin: 0 auto;
}
img {
  max-width: 100%;
}
.xt-btn {
  width: 272px;
  background-image: linear-gradient(0deg, #fb3331 0%, #ff712b 100%),
    linear-gradient(#cfa972, #cfa972);
  box-shadow: 0px 8px 12px 0px rgba(250, 44, 52, 0.29);
  color: #fff;
  padding: 0;
  height: 48px;
  font-size: 17px;
}
.el-button.is-round {
  border-radius: 23px;
  padding: 12px 23px;
}
a {
  text-decoration: none;
  color: #333;
}
a:hover {
  color: #cfa972;
}
.clearfix::after {
  display: block;
  content: "";
  width: 0;
  height: 0;
  clear: both;
}
.btn-more {
  text-align: center;
  display: block;
  width: 80px;
  margin: 0 auto;
  margin-top: 20px;
}
::-webkit-scrollbar-track-piece {
  background-color: #fff;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  background-color: #c2c2c2;
  background-clip: padding-box;
  min-height: 28px;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #a0a0a0;
}
</style>
